/* src/modules/dashboard/components/DataCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';

import styles from './styles';

const DataCard = ({ title, data, classes }) => (
  <Card className={classes.card}>
    <Typography color="primary" variant="title" align="center" className={classes.title}>
      {title}
    </Typography>
    {data.map(({ field, value }) => (
      <div className={classes.row} key={field}>
        <Typography variant="headline">
          {field}
        </Typography>
        <Typography variant="headline">
          {value}
        </Typography>
      </div>
    ))}
  </Card>
);

DataCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
};

DataCard.defaultProps = {
  data: [],
};

export default withStyles(styles)(DataCard);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/DataCard/index.js